<template>
   <div>
        <PageHeader :linkto="'/Sales/Dashboard'" :linkttitle="'返回'" title="分享點數"></PageHeader>

        <b-container>

            <b-input-group
                    class="mb-3"
                    prepend="搜尋使用者"
                    size="md"

            >
                <b-form-input
                        v-model="invitecode"
                        type="text"
                        maxlength="11"
                        required
                        placeholder="輸入手機號碼"
                        @change="checkvalue('invitecode')"
                ></b-form-input>
                <b-input-group-append>
                    <b-button  text="Button" variant="success"  @click="searchClient">送出</b-button>
                </b-input-group-append>
            </b-input-group>

            <b-card v-if="searchview" header="搜索結果" class="text-center">

                <div v-if="searchempty">
                    {{searchresult}}
                </div>
                <b-card v-else >
                    <b-row align-v="center">
                        <b-col>
                           {{searchresult.first_name + searchresult.last_name }}
                        </b-col>
                        <b-col>
                            {{searchresult.username  }}
                        </b-col>
                        <b-col>
                            {{searchresult.invite_num  }}
                        </b-col>
                        <b-col >
                            <h4> <b-button  size="sm" text="Button" variant="success"  @click="inviteClient"><b-icon-plus-circle></b-icon-plus-circle> 邀請加入</b-button></h4>
                        </b-col>
                    </b-row>

                </b-card>
            </b-card>
            <hr>
            <b-card no-body class="overflow-hidden p-2 mb-2">

                    <h4 class="mt-2">分享列表</h4>


            <b-table  striped hover :items="items" :fields="fields" :busy="isBusy" stacked="md">
                <template v-slot:table-busy>
                    <div class="text-center text-success my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>
                <template v-slot:cell(send_status)="row">
                    {{ getSendStatus(row.item.send_status)}}
                </template>
                <template v-slot:cell(plan)="row">
                    <b-form-select size="sm" v-model="items[row.index].plan" :options="options" :disabled="row.item.send_status == '1'"></b-form-select>
                </template>
                <template v-slot:cell(create_date)="row">
                    {{ gofnTime(row.item.create_date) }}
                </template>
                <template v-slot:cell(action)="row">
                    <b-button-group>
                        <b-button   v-if="row.item.send_status !== '1'" size="sm" @click="sendPlan(row.item)" variant="success">發送方案</b-button>
                        <b-button  v-if="row.item.send_status == '1' && row.item.status == '0'" size="sm" variant="primary" @click="delInviterPlan(row.item)">收回</b-button>


                        <p  v-if="row.item.send_status == '1' && row.item.status == '1'">已領取</p>
                    </b-button-group>
                </template>

            </b-table>
            </b-card>
        </b-container>
    </div>
</template>

<script>

import PageHeader from '@/components/PageHeader.vue'
import {toastsModel, alertModel,fnTime } from '@/service/commuse'


export default {
  name: 'MySocial',
  components: {PageHeader},
  data () {
    return {
      selected: null,
      invitecode:'',
      invitecode_check:false,
      searchview:false,
      searchempty:false,
      searchresult:'',

      options: [{ value: null, text: '請選擇'}],

      fields: [
        {
          key: 'numid',
          label: '序號',
          sortable: true
        },
        {
          key: 'name',
          label: '姓名',
          sortable: false
        },
        {
          key: 'username',
          label: '手機',
          sortable: true,
        },
        {
          key: 'plan',
          label: '方案',
          sortable: true,
        },
        {
          key: 'send_status',
          label: '狀態',
          sortable: true,
        },
        {
          key: 'action',
          label: '動作',
          sortable: true,
        },
        {
          key: 'create_date',
          label: '產生日期',
          sortable: true,
        },
      ],
      items: [],
      itemcheck:false,
      isBusy:false,
    }
  },
  computed: {

  },
  created(){
    this.$store.dispatch('actionGetCheckSales', {}).catch((res) =>{  this.$router.push('/home')})
  },
  mounted(){
    this.load();
    this.loadData();
  },
  methods: {
    load(){
      this.$store.dispatch('actionSalesSocialPlan', {provider:1,plantype:3}).then((res) => {
        res.data.forEach(element => {
          this.options.push( { value: element.product_id, text: element.product_name })
        });
      })
    },
    loadData(){
      let  d = new Date();
      this.$store.dispatch('actionMyInviteClient', {
        year:d.getFullYear(),
        month:d.getMonth()+1,
        day:'T',
        forwho:'G'
      }).then((res) => {
        this.items = [];
        let num = 0
        res.data.listdata.forEach(element => {
          let User = element.user_data
          num += 1
          this.items.push(  {
            numid: num,
            id: element.id,
            name:User.first_name+User.last_name,
            username: User.username,
            invite:User.invite_num,
            plan:element.puid,
            uuid:User.uuid,
            send_status:element.send_status,
            status:element.status,
            create_date:element.create_date
          },)
        });
      })
    },
    allSetPlan(){
      for (let i = 0; i <  this.items.length; i++) {
        if(this.selected !== null ){

          if(this.items[i]['status'] == 0 && this.items[i]['send_status'] == 0 ){
            this.items[i]['plan'] = this.selected
          }

        }
      }


    },
    checkvalue (way) {
      switch (way) {
        case 'invitecode':
          if (this.invitecode.length == 0) {
            this.invitecode_check = false
          } else {
            this.invitecode_check = true
          }
          break
        case 'item':
          for (let i = 0; i <  this.items.length; i++) {
            this.itemcheck = true
            if( this.items[i]['plan'] == ''){
              this.itemcheck = false
            }

          }

          break
        case 'allitem':

          let countTotal = 0;
          this.itemcheck = false
          for (let i = 0; i <  this.items.length; i++) {
            if( this.items[i]['plan'] === ''){
              countTotal =countTotal+1
              this.itemcheck = false
            }
          }
          if(countTotal==0){
            this.itemcheck = true
          }
          break
      }

    },
    searchClient(){
      this.checkvalue('invitecode')

      if( this.invitecode_check == true
      ){

        this.$store.dispatch('actionSearchClient', {
          phone:this.invitecode

        }).then((res) => {

          this.searchview = true
          this.searchresult = res.data
          this.searchempty = false

        }).catch((res) => {
          this.searchempty = true
          this.searchview = true
          this.searchresult = res.message
          this.invitecode = ''
        })
      }

    },
    inviteClient(){

      this.$store.dispatch('actionInviteSocialClient', {
        phone:this.invitecode,
        type:'G'
      }).then((res) => {

        this.searchempty = false
        this.searchview = false
        this.searchresult = ''
        this.invitecode = ''
        alertModel(this,"系統訊息",res.message)
        this.loadData();
      }).catch((res) => {
        alertModel(this,"系統訊息",res.message)
      })
    },
    sendPlan(data){

      if(data.plan!==""){
        this.isBusy = true
        this.$store.dispatch('actionSendPlanToClient', {
          send_group:data,
          type:'G'
        }).then((res) => {
          let resdata = res.data
          if(resdata.ok==1){
            alertModel(this,"系統訊息","完成發送").then(() => {
              this.loadData();
            })

          }else{
            alertModel(this,"系統訊息",resdata.errmsg).then(() => {

            })
          }

          this.isBusy = false
        }).catch((res) => {

          toastsModel(this, res.message)
          this.isBusy = false
        })
      }else{
        toastsModel(this, "請選擇發送方案")
      }


    },
    sendAllPlan(data){
      this.checkvalue('allitem')
      if( this.itemcheck == true
      ){
        this.isBusy = true
        this.$store.dispatch('actionSendPlanToClient', {
          send_group:data,
          type:"G"
        }).then((res) => {
          alertModel(this,"系統訊息","完成發送")
          this.loadData();
          this.isBusy = false
        }).catch((res) => {
          toastsModel(this, res.message)
          this.isBusy = false
        })
      }else{
        if(this.items.length>0){
          toastsModel(this, "請選擇發送方案")
        }else{
          toastsModel(this, "未邀請客戶")
        }

      }


    },
    delInviterPlan(item){

      this.isBusy = true

      this.$store.dispatch('actionReturnInviter', {
        id:item.id
      })
        .then((res) => {
          this.loadData();
          this.isBusy = false
        }).catch((res)=>{
        this.isBusy = false

      })
    },
    getSendStatus(num){
      let str = ' ';
      switch (num){
        case '0':
          str ='未發送'
          break;
        case '1':
          str ='已發送'
          break;
        case '2':
          str ='已收回'
          break;

      }
      return str

    }, gofnTime(time){
      return fnTime(time);
    }

  }
}
</script>
